export const CHEMKIT_UI_REFRESH_KEY = '__chemkit_ui_refresh_v';

export function readChemkitUiRefreshVersion(element) {
  if (!element || typeof element !== 'object') {
    return 0;
  }
  const value = element[CHEMKIT_UI_REFRESH_KEY];
  return Number.isFinite(value) ? value : 0;
}

export function cloneWithPrototype(element) {
  if (!element || typeof element !== 'object') {
    return element;
  }

  if (typeof element.clone === 'function') {
    try {
      return element.clone();
    } catch (_error) {
      // fallback below
    }
  }

  return Object.assign(Object.create(Object.getPrototypeOf(element)), element);
}

export function bumpChemkitUiRefreshVersion(element) {
  const base = readChemkitUiRefreshVersion(element);
  const next = base + 1;
  element[CHEMKIT_UI_REFRESH_KEY] = next;
  return next;
}

export function refreshActiveTabForChemkit({ selecteds, activeKey, currentElement }) {
  const list = Array.isArray(selecteds) ? selecteds : [];
  if (list.length === 0 || activeKey < 0 || activeKey >= list.length) {
    return { selecteds: list, activeKey, currentElement, version: 0 };
  }

  const activeElement = list[activeKey];
  if (!activeElement || typeof activeElement !== 'object' || Array.isArray(activeElement)) {
    return { selecteds: [...list], activeKey, currentElement, version: 0 };
  }

  const clonedActive = cloneWithPrototype(activeElement);
  const version = bumpChemkitUiRefreshVersion(clonedActive);

  const nextSelecteds = [...list];
  nextSelecteds[activeKey] = clonedActive;

  let nextCurrentElement = currentElement;
  if (currentElement === activeElement) {
    nextCurrentElement = clonedActive;
  }

  return {
    selecteds: nextSelecteds,
    activeKey,
    currentElement: nextCurrentElement,
    version,
  };
}
